<script lang="ts" module>
    export const route  = "/error";
    export const sessionRequired = false;
</script>

<script lang="ts">
    import { z } from "@repo/utils";
    import { useURL } from "../lib/url.svelte";
    import CircleX from "@lucide/svelte/icons/circle-x";
    import { resolveAuthError } from "../lib/messages.svelte.js";

    const url = useURL({ error: z.string(), error_description: z.string() });
</script>

<div class="flex size-full flex-col items-center justify-center gap-2 p-3 text-center">
    <div class="text-error-foreground">
        <CircleX size={32} />
    </div>
    <h3>{url.query.error ? (resolveAuthError(url.query.error) ?? url.query.error) : "Error"}</h3>
    {#if url.query.error_description}
        <div>{url.query.error_description}</div>
    {/if}
</div>
